<template>
   <div class="mb-3 mt-4">
       <w-title :text="title"></w-title>
       <v-breadcrumbs class="pl-1 pt-1" v-if="breadcrumbs && breadcrumbs.length" :items="breadcrumbs" divider=">"></v-breadcrumbs>
   </div>
</template>

<script>
    import WTitle from './WTitle.vue'
    export default{
        name: 'WMainTitle',
        props: ['breadcrumbs', 'title'],
        components: {
            WTitle
        }
    }
</script>